import { Settings2Icon } from 'lucide-react';

import { cn } from '@src/design-system/helpers';
import {
  Dialog,
  DialogContent,
  DialogTrigger,
} from '@src/design-system/dialog';

import { ReminderFilterModal } from './filters';
import ReminderChannelChip from './filters/reminder-channel-chip';
import ReminderContentTypeChip from './filters/reminder-content-type-chip';
import ReminderCreatedByChip from './filters/reminder-created-by-chip';

const filterTriggerClassName =
  'relative z-10 border cursor-pointer flex gap-1 px-3 items-center text-gray-800 border-pale-border bg-primary-50 text-sm';

export function ReminderTemplatesFilterDialog() {
  return (
    <Dialog>
      <DialogTrigger
        type='button'
        className={cn(filterTriggerClassName, 'h-10 rounded-lg')}
      >
        <Settings2Icon size={18} />
        Filter
      </DialogTrigger>

      <DialogContent>
        <ReminderFilterModal />
      </DialogContent>
    </Dialog>
  );
}

/** Attached to TiclickTable search; must sit above search input (z-2) to receive clicks. */
export function ReminderTemplatesTableFilterBtn() {
  return (
    <Dialog>
      <DialogTrigger
        type='button'
        className={cn(
          filterTriggerClassName,
          'h-10 border-l-0 rounded-r-lg shrink-0'
        )}
      >
        <Settings2Icon size={18} />
        Filter
      </DialogTrigger>

      <DialogContent>
        <ReminderFilterModal />
      </DialogContent>
    </Dialog>
  );
}

export function ReminderTemplatesActiveFilterChips() {
  return (
    <>
      <ReminderChannelChip />
      <ReminderContentTypeChip />
      <ReminderCreatedByChip />
    </>
  );
}
